import React, { Component, Fragment } from 'react';
import { Flex, Box, Button, Text, Heading, Card } from 'rebass';
import styled from 'styled-components';
import { compose, withApollo } from 'react-apollo';
import { withWizard } from 'react-albus';
import { withToastManager } from 'react-toast-notifications';

import LoadingScreen from '../../components/LoadingScreen';

import { CHARTS, CURRENT_USER } from '../../graphql';
import moment from 'moment';
import withSession from '../../lib/withSession';
import { sleep } from '../../utils/sleep';
import ScrollAnimation from 'react-animate-on-scroll';
import PleaseWait from '../PleaseWait';
import { bounceIn } from '../../utils/animationsStyleBuilder';
import { RotatingText } from '../../lib/components/RotatingText';

const Container = styled(Box)`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto;
  flex-direction: column;
  align-self: center;
`;
const Skip = styled(Text)`
  cursor: pointer;
`;

class InformationRollingText extends Component {
  state = {
    loading: true,
    errored: false,
  };
  componentDidMount() {
    this.handleSubmit();
  }

  handleSubmit = async () => {
    const { client, toastManager, data } = this.props;
    this.setState({ loading: true, errored: false });

    try {
      await client.mutate({
        mutation: CHARTS,
        variables: {
          data: this.props.userData,
          intakeStatus: data.status,
          intakeDate: data.status === 'completed' ? moment().format('MM-DD-YYYY') : null,
          intakeType: this.props.intakeType || 'hypo',
        },
        refetchQueries: [{ query: CURRENT_USER }],
        awaitRefetchQueries: true,
      });
    } catch (err) {
      console.log('Error submission', err);
      this.setState({ loading: false, errored: true });
      toastManager.add('Error submitting intake form', { appearance: 'error' });
      return;
    }
    try {
      await this.props.resetState();
      // this.handleRoute(skip);

      this.setState({ loading: false, errored: false });
      this.handleRoute();
    } catch (error) {
      this.setState({ loading: false, errored: true });
    }
  };

  handleRoute = (skip) => {
    const { data, wizard, moveToNext } = this.props;
    if (data.status === 'completed') {
      wizard.history.push(data.link);
    } else {
      if (skip) {
        wizard.push(skip);
        return;
      }
      wizard.next();
    }
  };

  render() {
    const { data } = this.props;
    const { loading, errored } = this.state;

    if (loading) {
      return (
        <Flex justifyContent="center" alignItems={'center'} style={{ zIndex: 1, flexDirection: 'column' }}>
          <PleaseWait
            text=" "
            spinner={{
              sColor: '#ECEFF2',
              pColor: '#909FB5',
            }}
          />
          {/* <Container> */}
          <RotatingText
            texts={[
              `Loading… because hormones are complicated!`,
              `If your thyroid could talk, it would be saying 'thank you' right now.`,
              `Loading… because great thyroid care is worth the wait!`,
              `Almost done — your thyroid is about to feel the love!`,
              `BRB — consulting with the thyroid gods.`,
              `Did you know? Women are 5 to 8 times more likely to develop a thyroid disorder than men.`,
            ]}
          />
          {/* </Container> */}
        </Flex>
      );
    }

    return (
      <Fragment>
        <Flex justifyContent="center" style={{ zIndex: 1 }}>
          <Flex width="600px" p={3}>
            <Card style={{ ...bounceIn() }}>
              <Flex flexDirection="column">
                <Box p={2} pt={4}>
                  <Text fontSize={'20px'} fontWeight={400} color="#344f77" textAlign="center">
                    {data.title}
                  </Text>
                </Box>

                <Box p={3} alignSelf="center">
                  {data.text.map((el, ind) => (
                    <Fragment key={ind}>
                      <Text lineHeight={1.6} textAlign="center">
                        {el}
                      </Text>
                    </Fragment>
                  ))}
                </Box>
              </Flex>

              <Flex alignItems="center" flexDirection="column" p={3}>
                {!!errored && (
                  <Button disabled={loading} type="button" variant="pink" width={[1, 1 / 2]} mb={3} onClick={() => this.handleSubmit()}>
                    Retry
                  </Button>
                )}
              </Flex>
            </Card>
          </Flex>
        </Flex>
      </Fragment>
    );
  }
}

export default compose(
  withApollo,
  withWizard,
  withToastManager,
  withSession
)(InformationRollingText);
